import axios from 'axios';
import Config from '@/Config';

const host = Config.host + "users/"


function isValid(){
  return axios.get(`${host}isValid`)
     .then(data => {
        return data.data
    })
}

function logout(){
  return axios.get(`${host}Logout`)
     .then(data => {
        return data.data
    })
}

function login(user, password){
  return axios.post(`${host}login`,{
    user: user,
    pass: password
  })
    .then(data => {
      return data.data
    })
}

function GetMe(){
  return axios.get(`${host}me`)
    .then(data => {
      return data.data
    })
    /* 
    
    "idUser": ,
    "user": "",
    "password": "",
    "name": "",
    "surNames": "",
    "email": "",
    "age": ,
    "role": "",
    "phoneNumber": ""
    */
}

function updateUser(user) {
  return axios.post(`${host}save`,{
    idUser: user.idUser,
    user: user.user,
    password: user.password,
    name: user.name,
    surNames: user.surNames,
    email: user.email,
    age: user.age,
    role: user.role,
    phoneNumber: user.phoneNumber
  })
    .then(data => {
      return data.data
    })
    .catch(error => {
    if (error.response) {
      // El backend respondió con un código de error
      console.error("Error desde el servidor:", error.response.data)

      // si quieres devolver el mensaje del backend
      throw new Error(error.response.data)
    } else if (error.request) {
      // No hubo respuesta del servidor
      console.error("No se recibió respuesta del servidor")
      throw new Error("Servidor no disponible")
    } else {
      // Error al configurar la petición
      console.error("Error en la petición:", error.message)
      throw new Error("Error inesperado")
    }
  })
}

function searchUsers(text, page = 0, country = "", city = "", role = "") {
  return axios.post(`${host}search`, {
    text: text,
    page: page,
    contry: country,
    city: city,
    role: role
  })
  .then(response => {
    // Retorna el PagedResponseDTO<User> (content, totalPages, etc.)
    return response.data;
  })
  .catch(error => {
    if (error.response) {
      // Manejo específico para el 403 (No es admin) o 401 (No login)
      console.error("Error de permisos o validación:", error.response.data);
      throw new Error(error.response.data);
    }
    throw new Error("Error en la conexión con el servidor");
  });
}

function save(user, password, name, surNames, email, age, role, phoneNumber, verificationCode){
  return axios.post(`${host}save`,{
    idUser: null,
    user: user,
    password: password,
    name: name,
    surNames: surNames,
    email: email,
    age: age,
    role: role,
    phoneNumber: phoneNumber,
    // El backend exige que corresponda al correo; sin el no crea la cuenta
    verificationCode: verificationCode
  })
    .then(data => {
      return data.data
    })
    .catch(error => {
    if (error.response) {
      // El backend respondió con un código de error
      console.error("Error desde el servidor:", error.response.data)

      // si quieres devolver el mensaje del backend
      throw new Error(error.response.data)
    } else if (error.request) {
      // No hubo respuesta del servidor
      console.error("No se recibió respuesta del servidor")
      throw new Error("Servidor no disponible")
    } else {
      // Error al configurar la petición
      console.error("Error en la petición:", error.message)
      throw new Error("Error inesperado")
    }
  })
}


function cambiarContrasena(contrasenaActual, nuevaContrasena) {
  return axios.post(`${host}changePassword`, {
    currentPassword: contrasenaActual,
    newPassword: nuevaContrasena
  })
    .then(data => data.data)
    .catch(error => {
      if (error.response) {
        throw new Error(error.response.data)
      }
      throw new Error("Error en la conexión con el servidor")
    })
}

/**
 * Pide que envien un codigo al correo. tipo: 'registro' o 'recuperacion'.
 * En recuperacion la respuesta es siempre la misma exista o no la cuenta,
 * para que no se pueda averiguar que correos estan registrados.
 */
function solicitarCodigo(correo, tipo){
  return axios.post(`${Config.host}VerificationCodes/request`, {
    email: correo,
    type: tipo
  })
    .then(data => data.data)
    .catch(error => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || error.response.data)
      }
      throw new Error('No pudimos conectar con el servidor')
    })
}

/**
 * Cambia la clave con el codigo que llego al correo, sin sesion y sin saber
 * la anterior. Distinto de cambiarContrasena, que es para quien ya entro.
 *
 * El codigo se quema al usarse: si esto falla por el codigo (vencido, errado,
 * demasiados intentos), hay que pedir uno nuevo.
 */
function recuperarContrasena(correo, codigo, nuevaContrasena){
  return axios.post(`${host}resetPassword`, {
    email: correo,
    code: codigo,
    newPassword: nuevaContrasena
  })
    .then(data => data.data)
    .catch(error => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || error.response.data)
      }
      throw new Error('No pudimos conectar con el servidor')
    })
}

export default {
  isValid,
  solicitarCodigo,
  recuperarContrasena,
  logout,
  login,
  GetMe,
  save,
  updateUser,
  searchUsers,
  cambiarContrasena
}
